export default __webpack_public_path__ + "static/media/single_web-sm@2x.bb99e4dd.webp";